import styled from 'styled-components';
import SvgIcon from '../../Icon/SvgIcon';
import { theme } from '../../../styles/theme';
import { IconName } from '../../Icon';

interface IProps {
  iconName: IconName;
  label: string;
  onClick: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  font-size: 12px;
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const SingleChartDataTooltipMenuItem = ({
  iconName,
  label,
  onClick,
}: IProps) => (
  <Container onClick={onClick}>
    <SvgIcon name={iconName} width={16} height={16} customFill="currentColor" />
    {label}
  </Container>
);

export default SingleChartDataTooltipMenuItem;
